export default "__VITE_ASSET__w5gQg1K6__"